export default __webpack_public_path__ + "static/media/480_dummy2016-allgemeinarzt01-mobile-de.0b52ac60.png";